import { Box } from '@mui/material'
import { Info } from './Info'
import { ToolContext } from '../../../../../core/context/ToolContext'
import { useContext, useState } from 'react'
import { Quiz } from './Quiz'
import { PostEval } from './PostEval'
import { VL } from './VL'
import { useHistory } from "react-router-dom";
import { useEffect } from 'react'
import { rqx } from '../../../../../core/request/API'
import { env } from '../../../../../core/Env'
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import { Pretest } from './Pretest'

const TakeCourse = ({match}) => {
    const __LOCATION = window.location.pathname;
    const { tab } = match.params
    const { navigation_state, information_state, tool_state, certificates_state } = useContext(ToolContext)
    const { openWidth, __SESSION: {data: { ainfo }}, info} = {...navigation_state, ...tool_state, ...certificates_state}
    const uid = window.atob(ainfo.aid).split('_').pop()
    const l = {pretest:Pretest, quiz: Quiz, 'post-evaluation': PostEval, 'video-lesson':VL}
    const List = l[tab]
    const nav = useHistory()
    let urlParams = new URLSearchParams(window.location.search);
    const [ title, setTitle] = useState('')
    
    const wideHandler = () => {
        openWidth.set(!openWidth.data);
    };

    const __init = async(id) => {
        let init;
        if (tab === 'pretest') {
            init = await rqx.get(`<<tool>>/${env()}/biz_exam/user_read_pretest`, { training_id: id , ref:'course'});
        } else if (tab === 'video-lesson') {
            init = await rqx.get(`<<tool>>/${env()}/biz_exam/user_read_VL`, {training_id:id, company_id: tool_state.cinfo.data[0].company_id, ref:'course'})

        } else if (tab === 'quiz') {
            init = await rqx.get(`<<tool>>/${env()}/biz_exam/user_read_Quiz`, {training_id:id, ref:'course'})

        } else {
            init = await rqx.get(`<<tool>>/${env()}/biz_exam/user_read_PostEvaluation`, {training_id:id, ref:'course'})
        }
        setTitle(init.title)
        
    }
    const getNextIncompleteStep = (trainingId, tContent, progress) => {
        const training = tContent.find(t => t.training_id === trainingId);
        if (!training) return null;
    
        const trainingProgress = progress.filter(p => p.training_id === trainingId);
    
        const steps = [];
    
        if (training.pretest_id !== null) steps.push({ type: 1, key: 'pretest' });
        steps.push({ type: 4, key: 'video-lesson' }); // always include video
        if (training.quiz_id !== null) steps.push({ type: 2, key: 'quiz' });
        if (training.post_evaluation_id !== null) steps.push({ type: 3, key: 'post-evaluation' });
    
    
        for (let step of steps) {
            const isDone = trainingProgress.some(p => p.exam_type === step.type && p.progress_status === 1);
            if (!isDone) return step.key;
        }
    
        return null; // all done
    };
    const trainingId = urlParams.get('id');
    useEffect(() => {
        __init(trainingId)
    }, [trainingId])

    return (
        <>
            <Box width="100%" bgcolor="#F5F8FF" px="40px" py="10px">
                <Box display="flex" alignItems="center">
                    <Box fontSize={14} fontWeight={400} color="#1893F1">Course</Box>
                    <Box mx="19.5px">
                        <ArrowForwardIosIcon sx={{ fontSize: 11 }} /> 
                    </Box>
                    <Box fontSize={14} fontWeight={400} >{title}</Box>
                </Box>
            </Box>
            <Box display="flex" flexDirection="row" flex={1} width="100%">
                <List openWidth={openWidth} wideHandler={wideHandler} cid={urlParams.get('cid')} certificates_state={certificates_state} uid={uid} information_state={information_state} nav={nav} info={info} getNextIncompleteStep={getNextIncompleteStep} tool_state={tool_state}/>
                <Info openWidth={openWidth} wideHandler={wideHandler} cid={urlParams.get('cid')} __LOCATION={__LOCATION} uid={uid} information_state={information_state} info={info} tool_state={tool_state}/>
            </Box> 
        </>
    )
}

export default TakeCourse;